import { useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import { useOrganizationSessionStorage } from "./use-browser-storage";

/**
 * Hook to manage custom channel and subchannel selection state via URL params and sessionStorage
 * Similar to useChannelSelection but for custom channels
 */
export function useCustomChannelSelection() {
  const { channelId } = useParams<{ channelId?: string }>();
  const navigate = useNavigate();

  // Decode the channel ID from the URL
  const selectedChannel = channelId ? decodeURIComponent(channelId) : undefined;

  // Use sessionStorage for subchannel selection (per-channel)
  const storageKey = selectedChannel
    ? `custom-channels::explorer::${selectedChannel}::subchannel`
    : "custom-channels::explorer::subchannel";

  const [selectedSubchannel, setStoredSubchannel] =
    useOrganizationSessionStorage<string | undefined>(storageKey, undefined);

  const setSelectedChannel = useCallback(
    (channel: string | undefined) => {
      if (channel) {
        navigate(`/custom-channels/${encodeURIComponent(channel)}/explorer`);
      } else {
        navigate("/custom-channels/explorer");
      }
    },
    [navigate],
  );

  const setSelectedSubchannel = useCallback(
    (subchannel: string | undefined) => {
      setStoredSubchannel(subchannel);
    },
    [setStoredSubchannel],
  );

  return {
    selectedChannel,
    selectedSubchannel,
    setSelectedChannel,
    setSelectedSubchannel,
  };
}
